






import Vue from "vue";
import { Component, Emit, Prop } from "vue-property-decorator";
import "./toggle.less";

@Component
export default class Toggle extends Vue {
  @Prop({ type: Boolean, default: false }) value;

  @Emit()
  input(value) {}
}
